import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PcDriver } from '../services/subscriptionAPI';

interface DriverStoreState {
	data: PcDriver[];
}

const INITIAL_STATE: DriverStoreState = {
	data: [],
};

// This slice is used for in progress, driver amends, across the table and form for complex restarts
const subscriptionAmendDriversSlice = createSlice({
	name: 'subscriptionAmendDrivers',
	initialState: INITIAL_STATE,
	reducers: {
		setDriverData(state, action: PayloadAction<PcDriver[]>) {
			state.data = action.payload;
		},
		removeDriver(state, action: PayloadAction<number>) {
			state.data.splice(action.payload, 1);
		},
		resetDrivers(state) {
			state.data = INITIAL_STATE.data;
		},
	},
});

export const { setDriverData, removeDriver, resetDrivers } = subscriptionAmendDriversSlice.actions;
export default subscriptionAmendDriversSlice.reducer;
